<h3>Copy Site and Transform its Structure</h3>

<div class="container" style="border:1px solid black">
  <div>
    <mat-form-field appearance="outline" style="width:400px">
      <mat-label>Site to Copy</mat-label>
      <mat-select [formControl]="siteId" [(value)]="siteId" style="width:100%">
        @for (site of sites; track site) {
          <mat-option [value]="site.id" title="{{site.name}}">{{site.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="outline">
      <mat-label>New Name</mat-label>
      <input matInput [formControl]="this.newName" />
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="outline" class="text-area">
      <mat-label>Paste JSON Here</mat-label>
      <textarea matInput class="text-area" rows="20" [formControl]="json"></textarea>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field appearance="outline">
      <mat-label>Count of FormInstances to Export</mat-label>
      <input matInput [formControl]="this.countOfFormInstanceToExport" />
    </mat-form-field>
  </div>

  <button mat-stroked-button
    class="button"
    (click)="this.doCopyAndTransform()">
    Copy And Transform
  </button>
  &nbsp;
  <button mat-stroked-button
    class="button"
    (click)="this.doExportAndTransform()">
    Export and Transform
  </button>
  &nbsp;
  <button mat-stroked-button
    class="button"
    (click)="this.doCopy()">
    Just Copy
  </button>
  @if (jobKey != null) {
    <div style="color: #EF0000;">Job started. JobKey is <a href="https://hp6955w1.sandbox.max.gov/api/copysite/GetExportedSiteZipFile/{{this.jobKey}}" target="_blank">{{this.jobKey}}</a></div>
  }
</div>
